// src/components/strumenti/RientroInvestimento.js — W442. Tempo di rientro (payback) e ROI semplice
import React from "react";
import { useCampi, Campo, Griglia, Risultato, Formula, Azzera, euro, fmt } from "./UiStrumento";
import { rientroInvestimento } from "../../utils/calcoliStrumenti";

export default function RientroInvestimento() {
  const { v, set, n, azzera } = useCampi({ inv:"", ben:"", anni:"10" });
  const r = rientroInvestimento(n("inv"), n("ben"), n("anni"));
  return (
    <div>
      <Griglia colonne={3}>
        <Campo etichetta="Investimento (€)" valore={v.inv} onChange={set("inv")} placeholder="Es. 12000"/>
        <Campo etichetta="Beneficio netto annuo (€)" valore={v.ben} onChange={set("ben")} placeholder="Es. 3000" aiuto="Risparmi o maggiori ricavi, meno i costi di gestione."/>
        <Campo etichetta="Anni di valutazione" valore={v.anni} onChange={set("anni")} placeholder="Es. 10"/>
      </Griglia>
      <Risultato settore="finanza" titolo="Tempo di rientro" valore={r?.paybackAnni ? fmt(r.paybackAnni, 1) : (r ? "mai" : "—")} unita={r?.paybackAnni ? "anni" : ""}
        righe={r ? [r.paybackMesi && ["In mesi", fmt(r.paybackMesi, 0)], r.guadagnoNetto !== null && [`Guadagno netto in ${fmt(n("anni"), 0)} anni`, euro(r.guadagnoNetto)], r.roiPct !== null && ["ROI sul periodo", fmt(r.roiPct, 1) + "%"]] : []}/>
      <Formula>Rientro = investimento ÷ beneficio annuo. ROI = (beneficio × anni − investimento) ÷ investimento. Calcolo semplice: beneficio costante, senza interessi, inflazione, tasse né incentivi.</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
